__turbopack_context__.v({
  "card": "FixStrategies-module__TgqiOG__card",
  "cardDesc": "FixStrategies-module__TgqiOG__cardDesc",
  "cardTitle": "FixStrategies-module__TgqiOG__cardTitle",
  "cardsRow": "FixStrategies-module__TgqiOG__cardsRow",
  "content": "FixStrategies-module__TgqiOG__content",
  "iconCheck": "FixStrategies-module__TgqiOG__iconCheck",
  "iconWrap": "FixStrategies-module__TgqiOG__iconWrap",
  "sectionBorder": "FixStrategies-module__TgqiOG__sectionBorder",
  "sectionSubTitle": "FixStrategies-module__TgqiOG__sectionSubTitle",
  "sectionTitle": "FixStrategies-module__TgqiOG__sectionTitle",
  "sectionTitleWrap": "FixStrategies-module__TgqiOG__sectionTitleWrap",
  "sectionWrapper": "FixStrategies-module__TgqiOG__sectionWrapper",
});
